import { render, staticRenderFns } from "./SuccessRevision.vue?vue&type=template&id=99e1b734"
import script from "./SuccessRevision.vue?vue&type=script&lang=js"
export * from "./SuccessRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports